module.exports = __webpack_public_path__ + "static/terre-44cd3f311837b1a810068ffc8f45b2b3.jpg";